import { types } from 'mobx-state-tree';


const WATER_SOURCE_TYPES = {
    MUNICIPAL: 'municipal',
    WELL: 'well',
};

const WaterSourceEnum = types.enumeration('WaterSource', Object.values(WATER_SOURCE_TYPES));

export {
    WaterSourceEnum,
};
export default WATER_SOURCE_TYPES;
